import { prisma, Prisma } from "client";

export const createMeetingRoom = async (
  data: Prisma.MeetingRoomCreateInput,
  translations: Prisma.MeetingRoomTranslationsCreateManyInput[],
  venueId: string,
  userId: string
) => {
  try {
    return prisma.meetingRoom.create({
      data: {
        ...data,
        venue: { connect: { id: venueId } },
        createdBy: { connect: { id: userId } },
        translations: {
          createMany: {
            data: translations,
          },
        },
      },
    });
  } catch (error) {
    console.error("error creating meeting room", error);
    throw error;
  }
};

export const getMeetingRoomById = async (id: string) => {
  try {
    return prisma.meetingRoom.findUnique({
      where: { id },
      include: {
        translations: {
          include: {
            language: true,
          },
        },
        venue: true,
        meetingRoomBookings: true,
      },
    });
  } catch (error) {
    console.error("error getting meeting room by id", error);
    throw error;
  }
};
export const getMeetingRooms = async (eventId: string) => {
  try {
    return await prisma.meetingRoom.findMany({
      where: {
        venue: {
          eventIds: {
            has: eventId,
          },
        },
      },
      include: {
        translations: true,
      },

      orderBy: { createdAt: "desc" },
    });
  } catch (error) {
    console.error("error getting meeting rooms", error);
    throw error;
  }
};

export const getMeetingRoomsPaginated = async (
  eventId: string,
  lang: string = "en",
  filters: {
    search?: string;
    page?: number;
    limit?: number;
  }
) => {
  try {
    const { search, page = 1, limit = 20 } = filters;

    const [rooms, total] = await Promise.all([
      prisma.meetingRoom.findMany({
        where: {
          venue: {
            eventIds: {
              has: eventId,
            },
          },
          ...(search && {
            translations: {
              some: {
                name: {
                  contains: search,
                  mode: "insensitive",
                },
              },
            },
          }),
        },
        include: {
          translations: {
            where: {
              language: {
                code: lang,
              },
            },
          },
        },
        skip: (page - 1) * limit,
        take: limit,
        orderBy: { createdAt: "desc" },
      }),
      prisma.meetingRoom.count({
        where: {
          venue: {
            eventIds: {
              has: eventId,
            },
          },
        },
      }),
    ]);

    const totalPages = Math.ceil(total / limit);

    return {
      data: rooms,
      pagination: {
        total,
        totalPages,
        hasNextPage: page < totalPages,
        hasPreviousPage: page > 1,
        currentPage: page,
      },
    };
  } catch (error) {
    console.error("error getting meeting rooms", error);
    throw error;
  }
};

export const updateMeetingRoom = async (
  id: string,
  data: Prisma.MeetingRoomUpdateInput,
  translations: Prisma.MeetingRoomTranslationsCreateManyInput[],
  venueId: string
) => {
  try {
    return prisma.meetingRoom.update({
      where: { id },
      data: {
        ...data,
        venue: { connect: { id: venueId } },
        translations: {
          deleteMany: {},
          createMany: {
            data: translations,
          },
        },
      },
    });
  } catch (error) {
    console.error("error updating meeting room", error);
    throw error;
  }
};

export const deleteMeetingRoom = async (id: string) => {
  try {
    return prisma.meetingRoom.delete({
      where: { id },
    });
  } catch (error) {
    console.error("error deleting meeting room", error);
    throw error;
  }
};
